import React, { useState } from "react";

export default function MyLockesComponent({ lockers }) {
  const [openedLockers, setOpenedLockers] = useState({});

  const handleOpenLocker = (id) => {
    setOpenedLockers((prev) => ({
      ...prev,
      [id]: true,
    }));
  };

  return (
    <>
      {lockers.map((locker) => {
        const isOpen = openedLockers[locker.id];

        return (
          <div key={locker.id} className="locker-card active-card">

            {/* Header */}
            <div className="top">
              <div className="title">{locker.name}</div>
              <div className="status active-status">Active</div>
            </div>

            <div className="sub-text">
              Locker {locker.size} size
            </div>

            {/* Dates */}
            <div className="date-section">
              <div className="date-box">
                <span className="label">Check-in</span>
                <span className="value">{locker.checkIn}</span>
              </div>

              <div className="date-box">
                <span className="label">Check-out</span>
                <span className="value">{locker.checkOut}</span>
              </div>
            </div>

            <hr />

            {/* 🔥 CONDITIONAL UI */}
            {!isOpen ? (
              /* BEFORE OPEN */
              <div className="locker-access">
                <div className="access-title">🔒 Locker Access</div>
                <div className="access-sub">
                  You've accessed this locker {locker.accessCount} times.
                </div>

                <button
                  className="open-btn"
                  onClick={() => handleOpenLocker(locker.id)}
                >
                  🔓 Open Locker
                </button>
              </div>
            ) : (
              /* AFTER OPEN */
              <div className="locker-open-box">
                <div className="open-title">🔓 Locker is Open!</div>
                <div className="open-sub">
                  Your locker is now unlocked. Please choose an option.
                </div>

                <div className="open-actions">
                  <button className="btn-light">Keep Using</button>
                  <button className="btn-success">Check Out</button>
                </div>
              </div>
            )}

            {/* Total */}
            <div className="total">Total: ${locker.total}</div>
          </div>
        );
      })}
    </>
  );
}